import client from './platformAPI';
import Invoice, { InvoiceAPIFields } from '../models/Invoice';
import { Payment } from '../models/Payment';
import { Company } from '../models/Company';

export type PaginatedInvoices = {
  total_pages: number;
  current_page: string;
  per_page: number;
  data: Invoice[];
};

export function getInvoices(page: number, per_page = 10): Promise<PaginatedInvoices> {
  return client.get(`/v1/invoices?per_page=${per_page}&page=${page}`).then((response) => {
    response.data.data = response.data.data.map((invoice: InvoiceAPIFields) =>
      Invoice.fromAPI(invoice),
    );
    return response.data;
  });
}

export function getInvoiceDownloadLink(id: string): Promise<string> {
  return client
    .get(`/v1/invoices/${id}/download_link`)
    .then((response) => response.data.download_link);
}

export function getPayments(): Promise<Payment> {
  return client
    .get('/v1/payments', { headers: { Tenant: 'ecuador' } })
    .then((response) => response.data);
}

export function updateBillingSettings(
  values: Company,
  country: string,
  overwriteTaxId = false,
): Promise<void> {
  values['overwrite_tax_id_account'] = overwriteTaxId;
  return client.post('/v1/billing_settings', values, {
    headers: { tenant: country },
  });
}
